import Dropdown from 'flarum/common/components/Dropdown';
import icon from 'flarum/common/helpers/icon';

export default class Multiselect extends Dropdown
{
    view(vnode) {
        const items = vnode.children instanceof Array ? vnode.children : [vnode.children];

        items.forEach((item) => {
            let parent = item;
            while ((parent?.children instanceof Array) && (typeof parent?.children?.[0] !== 'string')) {
                parent = parent.children[0];
            }

            const value = this.attrs.value ?? [];
            if (value.includes(parent?.children?.[0] || parent?.text)) {
                const icon_vnode = icon('fas fa-check', { style: 'padding-right: 1em;'});
                if (parent.children === undefined)
                    parent.children = Array(icon_vnode, parent.text && <>{parent.text}</>);
                else
                    parent.children.unshift(icon_vnode);

                // This is used instead of children if a vnode contains a text node as its only child.
                parent.text = undefined;
            }
        });

        return super.view(vnode);
    }
}
